import PocketBase from 'pocketbase'

export const POCKETBASE_URL =
  import.meta.env.VITE_POCKETBASE_URL ||
  (import.meta.env.DEV ? 'http://127.0.0.1:8090' : window.location.origin)

export const pb = new PocketBase(POCKETBASE_URL)
pb.autoCancellation(false)
